import { TEAS, TEA_WARNING, TEA_ANTES } from "@/data/teas";
import { elementColor } from "@/data/theme";
import { PageHeader, SafetyNote, SourceTag, ElementBadge } from "@/components/common";
import { Leaf } from "lucide-react";

export default function Teas() {
  return (
    <div className="space-y-10">
      <PageHeader
        eyebrow="Chás tradicionais citados no guia"
        title="Uma consulta educativa, com consciência"
        subtitle="Os chás abaixo aparecem ao longo do guia como referências tradicionais. Não substituem avaliação profissional e devem ser usados com bom senso."
      />

      <SafetyNote tone="warn">{TEA_WARNING}</SafetyNote>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TEAS.map((t) => {
          const c = elementColor(t.elemento);
          return (
            <div key={t.id} data-testid={`tea-card-${t.id}`} className="flex flex-col overflow-hidden rounded-3xl border border-border bg-card">
              <div className="p-6" style={{ backgroundColor: c.soft }}>
                <div className="flex items-center justify-between">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl" style={{ backgroundColor: "rgba(255,255,255,0.5)", color: c.primary }}>
                    <Leaf className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                  <SourceTag pages={t.sourcePages} />
                </div>
                <h3 className="mt-3 font-serif text-xl font-semibold" style={{ color: c.text }}>{t.foco}</h3>
                <p className="text-sm" style={{ color: c.primary }}>{t.orgaos}</p>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex flex-wrap gap-2">
                  {t.chas.map((ch, i) => (
                    <span key={i} className="rounded-full bg-secondary px-3 py-1.5 text-sm text-foreground capitalize">{ch}</span>
                  ))}
                </div>
                <p className="mt-4 text-xs leading-relaxed text-muted-foreground"><span className="font-medium text-foreground">Cuidado importante: </span>{t.cuidado}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="rounded-3xl border border-border bg-secondary/50 p-7">
        <h3 className="font-serif text-xl font-medium">Antes de tomar</h3>
        <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {TEA_ANTES.map((a, i) => (
            <div key={i} className="flex gap-2 rounded-xl bg-background/70 px-4 py-3 text-sm text-foreground"><span className="text-gold">•</span> {a}</div>
          ))}
        </div>
        <p className="mt-4 text-sm italic text-muted-foreground">“Cuidar também é saber quando pausar, observar e pedir orientação.”</p>
      </div>
    </div>
  );
}
